import ReactShadowRoot from 'react-shadow-root';

/**
 * Wraps components in a Shadow DOM to isolate external CSS.
 * Use this for components loading external CSS (e.g., banners, external newsletters)
 * to prevent style conflicts with the main application.
 *
 * Shadow DOM is natively supported in all modern browsers (Chrome 53+, Safari 10+, Firefox 63+).
 */
const withShadowRoot = Component => {
   const ShadowRootWrapper = props => (
      <div>
         <ReactShadowRoot>
            <Component {...props} />
         </ReactShadowRoot>
      </div>
   );
   ShadowRootWrapper.displayName = `withShadowRoot(${Component.displayName || Component.name || 'Component'})`;
   return ShadowRootWrapper;
};

export default withShadowRoot;
